import { isLoggedInAtom } from 'app/atoms';
import { useUser } from 'app/network/user';
import { DynamicFeatureFlag, isFeatureEnabled } from 'app/utils/helpers';
import { useAtomValue } from 'jotai';

export function useSocialFeedFeature() {
  const isLoggedIn = useAtomValue(isLoggedInAtom);
  const { data: currentUser, isPending } = useUser();

  return {
    canUseSocialFeed:
      isLoggedIn && !isPending && isFeatureEnabled(DynamicFeatureFlag.SocialFeed, currentUser?.featureFlags),
    isSocialFeedLoading: isLoggedIn && isPending,
  };
}
